import { Link } from 'react-router-dom';

import { Badge, Button } from '@pptcreate/ui';

export function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-lg flex-col items-center justify-center px-6 py-16 text-center">
      <Badge>404</Badge>
      <h1 className="mt-3 text-3xl font-bold uppercase">Page not found</h1>
      <p className="mt-3 text-brut-muted">That route does not exist in the editor app.</p>
      <Link to="/generate" className="mt-8 no-underline">
        <Button variant="primary" size="lg">Go to generate</Button>
      </Link>
    </main>
  );
}
